import React from "react";
import { useLocalization } from "@fluent/react";
import { RoutingNumberTextInput } from "cerulean";

import useInstitutionName from "./useInstitutionName";
import styles from "./RecipientDrawer.module.scss";

export default function RoutingNumberInput({value, routingType, ...props}: React.ComponentProps<typeof RoutingNumberTextInput> & { routingType: "ach" | "fedwire" }) {
  const { l10n } = useLocalization();
  const { institutionName, error } = useInstitutionName(value, routingType);

  return (
    <div>
      <RoutingNumberTextInput
        value={value}
        {...props}
        error={
          props.error ||
          (error
            ? l10n.getString("please-enter-a-valid-9-digit-routing-number")
            : undefined)
        }
      />
      {institutionName && (
        <div className={`margin--top--xs nds-input-subline ${styles.institutionDetails} ${styles.routingInstitution}`}>
          <span className="narmi-icon-bank"></span>
          <span className="fontColor--secondary">
            {institutionName}
          </span>
        </div>
      )}
    </div>
  );
}